import React from 'react';
import css from './Breadcrumbs.css';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

function Breadcrumbs() {
  return (
    <div className={css['breadcrumbs']}>
      <Link to="/">Waiting Room</Link>
      <Icon name="angle right" />
      <span>{`Today's Check Ins`}</span>
    </div>
  );
}

export default Breadcrumbs;
